// eslint-disable-next-line require-yield
export async function * globSource (): AsyncGenerator<any> {
  throw new Error('Not supported in browsers')
}
